module.exports = __webpack_public_path__ + "img/vsuite-logo-white.4ff8078c.png";